// @ts-nocheck
import { connect, useDispatch } from "react-redux";
import { setUser, UserInfo } from "../../store/main/actions";
import { useAsyncEffect } from "rooks";
import { getCredits, getUser } from "../../apiFunctions/user";
import { SetStateAction, useState } from "react";
import {
  ContentType,
  getSOPContentTypes,
} from "../../apiFunctions/sop/content_type";
import { classNames } from "../../utils/common";
import GenerationModal from "./GenerationModal";
import { Generation, getSop } from "../../apiFunctions/sop/utils";
import {
  LockClosedIcon,
  PlusIcon,
  CheckIcon,
} from "@heroicons/react/24/outline";
import { setGenerations } from "../../store/sop/actions";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { setNotification, NotificationStatus } from "../../store/main/actions";
import { parseError } from "../../utils/common";
import PremiumModal from "../generic/PremiumModal";
import Image from "next/image";
import dynamic from "next/dynamic";
// import { useCookies } from "react-cookie";

const Joyride = dynamic(() => import("react-joyride"), { ssr: false });

export interface CategoryCheckProps {
  userInfo: UserInfo;
  generations?: Generation[];
  setpurchaseModal: React.Dispatch<SetStateAction<boolean>>;
}

const CategoryCheck: React.FC<CategoryCheckProps> = ({
  userInfo,
  generations,
  setpurchaseModal,
}) => {
  const [contentTypes, setContentTypes] = useState<ContentType[]>();
  const [selectedContentType, setSelectedContentType] = useState<ContentType>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [Modal, setModal] = useState<boolean>(false);
  const router = useRouter();
  const { sopId, type } = router.query;
  const [Credits, setCredits] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(true);
  //   const [cookies, setCookie] = useCookies(["joyrideDisplayedd"]);
  const [joyrideDisplayed, setJoyrideDisplayed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMediumViewport = window.innerWidth >= 768;
      if (isMediumViewport) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const dispatch = useDispatch();
  useAsyncEffect(async () => {
    if (!userInfo) {
      try {
        let user = await getUser();
        dispatch(setUser(user));
      } catch (e: any) {
        if (e?.message != "Request failed with status code 404") {
          dispatch(
            setNotification({
              status: NotificationStatus.failed,
              message: parseError(e) ?? "Something went wrong",
            })
          );
        }
      }
    }

    if (!contentTypes) {
      try {
        let cts = await getSOPContentTypes(type as string);
        setContentTypes(cts);
      } catch (e: any) {
        if (e?.message != "Request failed with status code 404") {
          dispatch(
            setNotification({
              status: NotificationStatus.failed,
              message: parseError(e) ?? "Something went wrong",
            })
          );
        }
      }
    }
    try {
      const credits: any = await getCredits();
      setCredits(credits?.sop_credits);
    } catch (e: any) {
      console.log(e);
    }
    if (!generations) {
      if (!sopId) {
        return;
      }

      try {
        const sop = await getSop(sopId as string, type as string);
        dispatch(setGenerations(sop?.generations));
      } catch (e: any) {
        if (e?.message != "Request failed with status code 404") {
          dispatch(
            setNotification({
              status: NotificationStatus.failed,
              message: parseError(e) ?? "Something went wrong",
            })
          );
        }
      }
    }
  }, [userInfo, contentTypes, generations, sopId, type]);

  const onClickOpen = async (e: any, ct: ContentType) => {
    try {
      const credits: any = await getCredits();
      setCredits(credits?.sop_credits);

      if (!credits) {
        dispatch(
          setNotification({
            status: NotificationStatus.failed,
            message: "Something went wrong",
          })
        );
      }

      if (credits?.sop_credits <= 0) {
        setpurchaseModal(true);
        dispatch(
          setNotification({
            status: NotificationStatus.failed,
            message:
              "You need to purchase more credits to generate this section",
          })
        );
        return;
      }

      setSelectedContentType(ct);
      setOpenModal(true);
    } catch (e) {
      console.log(e);
      return;
    }
  };

  const [steps, setSteps] = useState<Step[]>([
    {
      target: ".sop-sections",
      content: "Click here to select the SOP selection",
      disableBeacon: true,
      placement: "right",
    },
  ]);
  const customStyles = {
    buttonNext: {
      backgroundColor: "#232559",
    },
    buttonBack: {
      backgroundColor: "#232559",
      color: "white",
      borderRadius: "5px",
      padding: "9px",
      marginRight: "20px",
    },
    buttonSkip: {
      color: "#232559",
      fontSize: "17px",
    },
  };
  const handleJoyrideCallback = (data) => {
    if (data.status === "finished") {
      setJoyrideDisplayed(true);
      if (typeof localStorage !== "undefined") {
        localStorage.setItem("joyrideDisplayedAtCategory", "true");
      }
    }
  };

  const shouldDisplayJoyride =
    visible &&
    !joyrideDisplayed &&
    (typeof localStorage === "undefined" ||
      !localStorage.getItem("joyrideDisplayedAtCategory"));

  return (
    <>
      {shouldDisplayJoyride && (
        <Joyride
          steps={steps}
          styles={customStyles}
          showSkipButton={true}
          callback={handleJoyrideCallback}
        />
      )}
      <PremiumModal open={Modal} setOpen={setModal} />
      <fieldset className="sticky md:top-10 md:py-4 md:border-r-2 pr-4 ">
        <legend className="sr-only">Sop Sections</legend>
        <p className="text-tootler-primary-900 text-sm font-semibold">
          AI Tootler Sections
        </p>
        <p className="text-base mt-2 pb-6 text-tootler-grey-500">
          Click on the section below to add them to your SOP
        </p>
        <div className="sop-sections">
          {contentTypes?.map((ct: ContentType, index) => {
            let generated = generations?.find(
              (gen: Generation) => gen.content_type_id == ct.id
            );

            return (
              <div
                key={index}
                className={`relative flex  ${
                  generated
                    ? " rounded-xl bg-green-10 hover:ring-1 transition active:bg-semantic-success/10 focus-visible:bg-semantic-success/10 focus-within:bg-semantic-success/10 focus:bg-semantic-success/10 ring-semantic-success"
                    : "hover:bg-tootler-primary-400/10 transition duration-300 rounded-xl"
                }   cursor-pointer py-2 mb-4  md:mt-3 md:mb-8 md:py-4 items-center`}
                onClick={(e) => onClickOpen(e, ct)}
              >
                <div className="flex items-center">
                  {index < 2 && Credits < 10 ? (
                    // make a circle with a border and a checkmark inside

                    <LockClosedIcon className="w-5 h-5 text-gray-400" />
                  ) : index >= 2 && Credits < 10 ? (
                    <>
                      <LockClosedIcon className="w-5 h-5 text-gray-400" />
                    </>
                  ) : (
                    // <input
                    //   id="comments"
                    //   aria-describedby="comments-description"
                    //   name={ct.title}
                    //   type="checkbox"
                    //   className="accent-primary-500 h-4 w-4 rounded cursor-pointer border-gray-300 text-primary-500 focus:ring-primary-400
                    //   bg-dark-800"
                    // />

                    <div
                      className={classNames(
                        index < 2
                          ? "md:text-gray-700 text-gray-100"
                          : "text-gray-400",
                        "cursor-pointer font-medium px-4 "
                      )}
                    >
                      <PlusIcon
                        strokeWidth={2}
                        className={`h-6 w-6 text-tootler-primary-400 ${
                          generated ? "hidden" : ""
                        } `}
                      />
                      <CheckIcon
                        strokeWidth={2}
                        className={`h-6 w-6 text-semantic-success ${
                          generated ? "" : "hidden"
                        }`}
                      />
                    </div>
                  )}
                </div>
                <div className=" ">
                  <label
                    htmlFor={ct.title}
                    className={classNames(
                      userInfo?.sop_credits >= 10
                        ? generated
                          ? "text-semantic-success"
                          : "md:text-tootler-primary-900 text-primary-900"
                        : "text-gray-400",
                      "cursor-pointer font-medium ",
                      generated ? "text-semantic-success" : ""
                    )}
                  >
                    {ct.title}
                    {/*<p
                    id="comments-description"
                    className={classNames(
                      userInfo?.sop_credits >= 10
                        ? "text-gray-500"
                        : "text-gray-400",
                      "max-w-md text-sm font-normal"
                    )}
                  >
                    {ct.description}
                  </p> */}
                  </label>
                </div>
              </div>
            );
          })}
        </div>
      </fieldset>
      <GenerationModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        contentType={selectedContentType}
      />
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userInfo: state.main.userInfo,
    generations: state.sop.generations,
  };
};
export default connect(mapStateToProps)(CategoryCheck);
